import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const parcelDetailLocaleModule: LocaleModule = {
  name: "parcelDetail",
  messages: { en: en, it: it },
};
